import { useDefaultSite } from './useDefaultSite';
import { useCurrentOrganization } from './useOrganization';

export function useAnalyticsOwner() {
  const { data: organization } = useCurrentOrganization();
  const { currentSite } = useDefaultSite();

  const organizationId = organization?.id;
  const siteId = currentSite?.id;
  const ownerId = siteId ?? organizationId;
  const ownerType: 'site' | 'organization' = siteId ? 'site' : 'organization';
  const isReady = !!organizationId;

  return { ownerId, ownerType, organizationId, siteId, isReady } as const;
}
